// 5 hazır tema — sadece zemin değil, vurgu/koyu renkler ve arka plan tonları dahil komple görünüm.
export const TEMALAR = [
  {
    id: 'turuncu',
    ad: 'Turuncu Klasik',
    accent: '#e8600c',
    koyu: '#1e2a3a',
    bgUst: '#2d3f56',
    bgOrta: '#1e2a3a',
    bgAlt: '#10161f',
    kartUst: '#fff6ee'
  },
  {
    id: 'yesil',
    ad: 'Zeytin Bahçesi',
    accent: '#7cb342',
    koyu: '#1b3324',
    bgUst: '#2f5741',
    bgOrta: '#1b3324',
    bgAlt: '#0d1a12',
    kartUst: '#f3f8ee'
  },
  {
    id: 'lacivert',
    ad: 'Gece Lacivert',
    accent: '#d4af37',
    koyu: '#0d1b3e',
    bgUst: '#16244f',
    bgOrta: '#0d1b3e',
    bgAlt: '#060d20',
    kartUst: '#fdf8ec'
  },
  {
    id: 'pastel',
    ad: 'Pastel Cafe',
    accent: '#e07a9e',
    koyu: '#4a3f6b',
    bgUst: '#5c4f80',
    bgOrta: '#4a3f6b',
    bgAlt: '#2c2540',
    kartUst: '#fdf3f8'
  },
  {
    id: 'kirmizi',
    ad: 'Modern Kırmızı',
    accent: '#c0392b',
    koyu: '#1a1a1a',
    bgUst: '#2b2b2b',
    bgOrta: '#1a1a1a',
    bgAlt: '#0a0a0a',
    kartUst: '#fdf3f2'
  }
];

export const temaGetir = (id) => TEMALAR.find((t) => t.id === id) || TEMALAR[0];
